import ppSacCustomOptions from '../../../js/lib/ppSacCustomOptions';

const transformCallUsInfo = (callUsInfo, formFields, finalIntentSelected, chatbotParams) => {
  const sacOptions = ppSacCustomOptions(callUsInfo, formFields, finalIntentSelected, chatbotParams);

  const generalCallUsInfo = {
    phoneNumbers: callUsInfo.isphonePresent ? callUsInfo.phoneNumbers : [],
    specialInstruction: callUsInfo.isInstructionPresent ? callUsInfo.Special_Instruction : '',
    webPin: callUsInfo.web_pin,
    mtsPhone: callUsInfo.isMTSPresent ? callUsInfo.Account_Manager_MTS_Display : '',
    generalMTS: callUsInfo.isMTSPresent ? callUsInfo.General_MTS_Display : '',
    generalPhoneNumber: callUsInfo.General_Phone_Number || '',
    amPhone: callUsInfo.Account_Manager_Phone_Number || '',
    amFlag: callUsInfo.Account_Manager_Flag_Name || '',
    accountManagerEmail: callUsInfo.Account_Manager_Email_Address || '',
    customerHour: {
      hoursOfService: callUsInfo.Hours_of_Service_1 || '',
      generalTime1: callUsInfo.General_Available_Time_1 || '',
      generalTime2: callUsInfo.General_Available_Time_2 || '',
      amTime1: callUsInfo.Account_Manager_Available_Time_1 || '',
      amTime2: callUsInfo.Account_Manager_Available_Time_2 || '',
      amPerCall: callUsInfo.Account_Manager_Cost_Per_Call || '',
    },
  };

  if (sacOptions) {
    return {
      ...generalCallUsInfo,
      phoneNumbers: [sacOptions.phoneValue],
      customerHour: {
        hoursOfService: sacOptions.HoursOfOperation,
      },
    };
  }

  return generalCallUsInfo;
};

export default transformCallUsInfo;
